import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeShipmentRoutingTypes } from './normalize';

export const fetchShipmentRoutingTypes = createProvider(api.fetchShipmentRoutingTypes)
  .andThen((res) => normalizeShipmentRoutingTypes(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
